import React, {Component} from 'react';
import cx from 'classnames';
import st from './Icon.module.sass';
import PropTypes from 'prop-types';

class Icon extends Component {
  render() {
    const {children, className: cnBox, icon, onClick, style: stl = {}} = this.props;
    if (icon) stl.backgroundImage = `url(${icon})`;

    return (
      <div
        className={cx(st.icon, cnBox)}
        style={stl}
        onClick={onClick}
      >
        {children}
      </div>
    );
  }
}

Icon.propTypes = {
  style: PropTypes.object,
  icon: PropTypes.any,
  children: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Icon;


// WEBPACK FOOTER //
// ./src/components/common/Icon/Icon.jsx